import axios from "axios";

const URL = "https://topups.reloadly.com/";
const TOKEN_EXPIRY_BUFFER = 86400; // 1 day buffer to avoid edge cases
const ACCESS_TOKEN = "uBEiuHBXrDfiuthssKUQFN4xyJzmWPj3"; // Replace with actual access token

const getToken = async () => {
  const clientId = localStorage.getItem("clientId");
  const clientSecret = localStorage.getItem("clientSecret");

  // Check if the token is stored, not expired, and matches the current client credentials
  const cachedClientId = localStorage.getItem("cachedClientId");
  const cachedClientSecret = localStorage.getItem("cachedClientSecret");
  const tokenExpiry = localStorage.getItem("tokenExpiry");
  
  if (tokenExpiry && new Date().getTime() < tokenExpiry && 
      cachedClientId === clientId && cachedClientSecret === clientSecret) {
    return localStorage.getItem("token");
  }

  // If no valid token or client credentials do not match, request a new one
  const url = "https://auth.reloadly.com/oauth/token";
  const payload = {
    client_id: clientId,
    client_secret: clientSecret,
    grant_type: "client_credentials",
    audience: URL,
  };

  const response = await axios.post(url, payload);

  // Cache the new token, client credentials, and its expiry time
  const expiresIn = response.data.expires_in - TOKEN_EXPIRY_BUFFER; // Subtract buffer
  const expiryTime = new Date().getTime() + expiresIn * 1000;
  localStorage.setItem("token", response.data.access_token);
  localStorage.setItem("tokenExpiry", expiryTime);
  localStorage.setItem("cachedClientId", clientId);
  localStorage.setItem("cachedClientSecret", clientSecret);

  return response.data.access_token;
};

const setNumberExpiry = async (number, success = true) => {
  const url = `https://frek.cc/proxy/38.54.86.24:5000/expiry/${number}`;
  const value = success
    ? new Date(new Date().getTime() + 2 * 24 * 60 * 60 * 1000).toISOString().slice(0, 19).replace('T', ' ')
    : "1970-01-01 13:00:00";

  try {
    const response = await axios.post(
      url,
      { value },
      {
        headers: {
          "Content-Type": "application/json",
          "x-access-token": ACCESS_TOKEN, // Replace with actual access token
        },
      }
    );

    if (response.status === 200) {
      console.info(`${number} Expiry set!`);
      if (success) {
        const flaskResponse = await axios.post("https://frek.cc/proxy/38.54.86.24:6987/load", {
          json: 1,
        });
        if (flaskResponse.status === 200) {
          console.info(`Load count incremented for ${number}.`);
        } else {
          console.error(`Failed to increment load count for ${number}. Status code: ${flaskResponse.status}`);
        }
      }
    } else {
      console.info(`Request failed for number ${number} with status: ${response.status}`);
    }
  } catch (e) {
    console.info(`An error occurred while setting expiry for number ${number}: ${e}`);
  }
};

const topUp = async (operatorId, amount, phoneNumber) => {
  try {
    const token = await getToken();
    const url = URL + "topups";
    const payload = {
      operatorId: operatorId,
      amount: parseInt(amount),
      useLocalAmount: true,
      recipientPhone: {
        countryCode: "PH",
        number: phoneNumber,
      },
    };

    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/com.reloadly.topups-v1+json",
      "Content-Type": "application/json",
    };

    const response = await axios.post(url, payload, { headers });
    const result = {
      phoneNumber,
      operatorId: response.data.operatorId,
      operatorName: response.data.operatorName,
      status: response.data.status,
      deliveredAmount: response.data.deliveredAmount,
      oldBalance: response.data.balanceInfo.oldBalance,
      newBalance: response.data.balanceInfo.newBalance,
      transactionId: response.data.transactionId,
      errorCode: "",
      message: "",
    };

    saveResultToLocalStorage(result);

    // Call setNumberExpiry on success
    await setNumberExpiry(phoneNumber, true);

    return result;
  } catch (error) {
    const result = {
      phoneNumber,
      operatorId: "",
      operatorName: "",
      status: "",
      deliveredAmount: "",
      oldBalance: "",
      newBalance: "",
      transactionId: "",
      errorCode: error.response.data.errorCode,
      message: error.response.data.message,
    };
    saveResultToLocalStorage(result);

    // Call setNumberExpiry on failure
    await setNumberExpiry(phoneNumber, false);

    return result;
  }
};

function saveResultToLocalStorage(result) {
  // Retrieve existing results from localStorage, or initialize an empty array
  const existingResults = JSON.parse(localStorage.getItem('topUpResults')) || [];

  // Add the new result to the array
  existingResults.push(result);

  // Save the updated array back to localStorage
  localStorage.setItem('topUpResults', JSON.stringify(existingResults));
}

const checkBalance = async () => {
  try {
    const token = await getToken();
    const balanceUrl = "https://topups.reloadly.com/accounts/balance";

    const headers = {
      Authorization: "Bearer " + token,
      Accept: "*/*",  // Accepting any content type
    };

    const response = await axios.get(balanceUrl, { headers });
    if (response.data) {
      return response.data;  // Contains balance details
    } else {
      // Handle the case where response.data is null
      console.error("Received null response data");
      return null;
    }
  } catch (error) {
    console.error("Error checking balance:", error);
    return null;
  }
};

export { topUp, checkBalance };
